export default "__VITE_ASSET__CP6JAdCE__"